import React from "react";
import { Box, Menu } from "@mui/material";
import CartItemCard from "./CartItemCard";
import "./CartDropdown.scss";

const CartDropdown = ({ handleClose, cartItems, anchorEl, isOpen }: any) => {
  const open = Boolean(anchorEl);

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen ?? false}
      onClose={handleClose}
      className="cartDropdown"
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <Box className="cartContent">
        <CartItemCard cartItems={cartItems} handleClose={handleClose} />
      </Box>
    </Menu>
  );
};

export default CartDropdown;
